<template>
  <div>
    <v-flex v-if="simc && showSelect" xs12 pr-2>
      <v-autocomplete
        v-model="selectedUlic"
        clearable
        hide-no-data
        placeholder="Wpisz nazwę ulicy"
        item-text="nameFull"
        item-value="symbol"
        :items="streets"
        :search-input.sync="search"
      >
        <div slot="label">Ulica<span v-if="model.ulic.$schema.fieldRequired"> *</span></div>
        <template v-slot:append-outer>
          <v-btn bottom large flat color="success" @click="saveUlic">Dodaj</v-btn>
        </template>
      </v-autocomplete>

      <p class="autocomplete-warning">
        {{ error }}
        <slot name="errors" />
      </p>

      <slot />
    </v-flex>
  </div>
</template>

<script>
import { notificationsMixin } from '@/mixins/notifications';
import { checkIfStreetsExist, searchStreets } from '@/utils/ulicHelper';

// @vuese
// Input na ULIC-a
// @group Components/Forms
export default {
  mixins: [notificationsMixin],
  props: {
    // Schema
    model: {
      type: Object,
      required: true
    },
    // Wartość TERC-a
    terc: {
      type: String,
      required: true
    },
    // Wartość SIMC-a
    simc: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      streets: [],
      search: '',
      showSelect: false,
      selectedUlic: '',
      error: ''
    };
  },
  watch: {
    simc(newValue) {
      this.streets = [];
      this.model.$setData({
        streets: '',
        ulic: ''
      });
      this.checkULICList();
    },
    search(val) {
      if (val) {
        this.searchULICList(val);
      }
    }
  },
  beforeMount() {
    this.checkULICList();
  },
  methods: {
    // @vuese
    // Sprawdza czy lista ulic nie jest pusta
    async checkULICList() {
      if (this.terc && this.simc) {
        try {
          const hasStreets = await checkIfStreetsExist(this.terc, this.simc);
          this.showSelect = hasStreets;
        } catch (error) {
          this.notifyError('Nie udało się pobrać listy ulic');
        }
      }
    },
    // @vuese
    // Przeszukuje listę ulic
    async searchULICList(val) {
      if (this.terc && this.simc) {
        try {
          this.streets = await searchStreets(this.terc, this.simc, val);
          this.error = '';
        } catch (error) {
          this.notifyError('Nie udało się pobrać listy ulic');
        }
      }
    },
    // @vuese
    // Zapisuje wybraną ulicę lub wyświetla komunikat o błędzie
    saveUlic() {
      if (this.selectedUlic) {
        const name = this.streets.find(item => item.symbol === this.selectedUlic).nameFull;
        // Emituje event do zapisu wartości ULIC
        // @arg Obiekt z wartością ULIC i nazwą ulicy
        this.$emit('saveUlic', { ulic: this.selectedUlic, name });
        this.streets = [];
        this.selectedUlic = '';
      } else {
        this.error = 'Proszę wpisać nazwę ulicy przed dodaniem';
      }
    }
  }
};
</script>

<style scoped>
.autocomplete-warning {
  color: red;
  margin-top: -20px;
}
</style>
